<template>
  <div class="presents">
    <h1>CNS&nbsp;Theater&nbsp;Guild Presents</h1>
  </div>
  <div class="home">
    <img alt="12 Angry Jurors" src="../assets/jurors.jpg" />
    <div class="write-up">
      <h3>12 Angry Jurors</h3>
      <p>
        Twelve Angry Men (Jurors) is an American courtroom drama written by
        Reginald Rose concerning the jury of a homicide trial. It was broadcast
        initially as a television play in 1954. The following year it was
        adapted for the stage. It was adapted for a film of the same name,
        directed by Sidney Lumet and released in 1957. Since then it has been
        given numerous remakes, adaptations, and tributes.
      </p>
      <p>
        The play explores the deliberations of a jury of a homicide trial, in
        which a dozen "men with ties" decide the fate of a teenager accused of
        murdering his abusive father. At the beginning, they are nearly
        unanimous in concluding the youth is guilty. One man dissents, declaring
        him "not guilty", and he sows a seed of reasonable doubt. Eventually he
        persuades the other jurors to support a unanimous "not guilty" verdict.
      </p>
    </div>
  </div>
  <div class="logos">
    <div class="perf">
      <img alt="Performing Arts" class="perf" src="../assets/perfarts.png" />
    </div>
    <div class="dvlogo">
      <img alt="DV Logo" class="dvlogo" src="../assets/driversVillage.jpg" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
};
</script>
<style>
.home {
  display: grid;
  grid-template-columns: 1fr 3fr;
  align-items: center;
  margin: 0 15vw;
}

.home img {
  width: 100%;
}

.home .write-up {
  padding: 0 0 0 2rem;
}
.presents {
  display: flex;
}
.dvlogo {
  width: 15rem;
  margin-right: 1rem;
  margin-left: 1.5rem;
  padding-left: 0.5rem;
  padding-top: 25px;
  float: left;
}
.perf {
  margin-left: 1rem;
  padding-top: 40px;
  float: left;
  width: 20rem;
}
.logos {
  position: relative;
  align-items: center;
}
h1 {
  font-size: clamp(2rem, 3vw, 3rem);
  padding: 0 1rem;
}

h3 {
  font-size: clamp(1.5rem, 2vw, 2.5rem);
}
p {
  font-size: 1.5vw;
}

@media (max-width: 850px) {
  .home {
    grid-template-columns: 1fr;
    margin: 0 1rem;
  }

  .home .write-up {
    padding: 0;
  }

  p {
    font-size: 1rem;
  }
}
</style>
